import { ReactElement } from 'react';
import { isAxiosError } from 'axios';
import { Navigate, useRouteError } from 'react-router-dom';
import { useStore } from 'zustand';

import { hasToken } from 'entities/session';

import { LONG_TOAST_DURATION } from 'shared/config';
import { pathKeys } from 'shared/lib/react-router';
import { toastStore } from 'shared/model/toast';
import { Maybe } from 'shared/types';

// TODO: improve
export function BubbleError(): Maybe<ReactElement> {
  const error = useRouteError();
  const { addToast } = useStore(toastStore);

  if (isAxiosError(error)) {
    const status = error?.response?.status;
    const isAuthorized = hasToken();

    if (status === 401 && isAuthorized) {
      return <Navigate to={pathKeys.logout()} />;
    }

    if (status === 401) {
      return <Navigate to={pathKeys.login()} />;
    }

    if (status === 403) {
      addToast({
        key: 'access-denied',
        type: 'critical',
        duration: LONG_TOAST_DURATION,
        method: 'warning',
        description: 'Exception:AccessDeniedException',
      });
      return <Navigate to={pathKeys.logout()} />;
    }

    if (status === 404) {
      return <Navigate to={pathKeys.page404()} />;
    }
  }
  if (error) throw error;
  return null;
}
